import React from "react";
// MDBShim Imports
import MDBCard from "../../../Component/MDBShim/MDBCard";
import MDBCardBody from "../../../Component/MDBShim/MDBCardBody";
import MDBCardHeader from "../../../Component/MDBShim/MDBCardHeader";
import MDBCol from "../../../Component/MDBShim/MDBCol";
import MDBIcon from "../../../Component/MDBShim/MDBIcon";
import MDBModal from "../../../Component/MDBShim/MDBModal";
import MDBModalBody from "../../../Component/MDBShim/MDBModalBody";
import MDBRow from "../../../Component/MDBShim/MDBRow";
import MDBBtn from "../../../Component/MDBShim/MDBBtn";
import MDBBtnGroup from "../../../Component/MDBShim/MDBBtnGroup";
import ReactTooltip from "react-tooltip";
import PropTypes from "prop-types";
import NoteService from "../../Security/NoteService/noteService";
import GlobalFunctions from "../../Filters/GlobalFunctions";
import MainContext from "../../../Context/MainContext/MainContext";

export default class NotesTab extends React.Component {
    constructor(props) {
        super(props);

        this.toggleNoteModal = props.toggleNoteModal;
        this.refreshNotes = props.getNotes;
        this.toggleNoteModalPopup = props.toggleNoteModalPopup;
        this.toggleFieldNotesModalPopup = props.toggleFieldNotesModalPopup;
        this.downloadNotes = props.downloadNotes;


        let notes = [];
        if(props.allNotes){
            props.allNotes.forEach(x => {
                if(x.deleted !== true){
                    notes.push(x);
                }
            });
        }

        this.state = {
            allNotes: notes,
            editNoteOpen: false,
            taskCompleted: true,
            modalNote: {},
            noteAssignedTo: null,
            eOrder: props.eOrder,
            selectedNoteTypesArray: [],
            fullWidth: props.fullWidth,
            isOrderDetails: props.isOrderDetails,
        };
    }

    static contextType = MainContext; // For legacy class components

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.allNotes !== prevState.allNotes) {
            return {allNotes: nextProps.allNotes};
        } else if (nextProps.eOrder !== prevState.eOrder) {
            return {eOrder: nextProps.eOrder};
        } else return null;
    }

    sortNotes(allNotes, task) {
        let t = [],
            n = [];

        let sorted = allNotes.sort((a,b) => {
            let da = new Date(a.createdAt).getTime(),
                db = new Date(b.createdAt).getTime();

            return da > db ? -1: 1;
        });


        if(this.state.isOrderDetails){
            return sorted;
        }else

            sorted.forEach((note) => {
                if (note) {
                    if (note.completed === false) {
                        t.push(note);
                    } else {
                        n.push(note);
                    }
                }
            });


        if (task) {
            return t;
        }
        return n;
    }

    updateNoteModal(note) {
        const {currentUser} = this.context;

        let nText = document.getElementById("noteTextArea").value;

        let upDate = "Updated: " + GlobalFunctions.formatDateTimeTimeZone(GlobalFunctions.getUTCMoment()),
            by = " -- By: " + currentUser.username;
        note.text = nText + " -- " + upDate + by;

        this.updateNote(note, null);
    }

    updateNote(note, complete) {
        const {currentUser} = this.context;

        let notes = this.state.allNotes,
            noteToReplace = notes.findIndex((n) => {
                return n.id === note.id;
            });

        if (noteToReplace > -1) {
            notes.splice(noteToReplace, 1, JSON.parse(JSON.stringify(note)));
        }

        if (complete != null) {
            note.completed = complete;

            note.text +=
                " --> Completed by " +
                currentUser.username +
                " on " +
                new Date().toLocaleString();
        }
        //let account = (this.state.eOrder.activity.account ? this.state.eOrder.activity.account.id : this.state.eOrder.activity.accountId);
        return NoteService.updateActivityNote(note)
            .then((res) => {
                this.refreshNotes();
                //this.setState({
                //    allNotes: notes,
                //});
            })
            .catch((err) => {
                console.log(err);
            });
    }

    toggleEditModalPopup(note) {
        const {currentUser} = this.context;

        let currentState = this.state.editNoteOpen,
            ncopy = {};

        if (note) {
            ncopy = JSON.parse(JSON.stringify(note));

            if (currentUser) {
                if (
                    currentUser.role === "ADMIN"
                ) {
                    //we are fine, continue
                } else if (currentUser.id !== note.createdBy.id) {
                    //they do not own this note.  They shouldn't be able to edit it.
                    return;
                } else {
                    //determine if within 24 hours...BC
                    let ca = new Date(note.createdAt).getTime(),
                        n = new Date().getTime();

                    if (n - ca < 86400000) {
                        //this note is within 24 hours, continue...BC
                    } else {
                        //This note is older than 24 hours.  do not continue...BC
                        return;
                    }
                }
            } else {
                return;
            }
        }

        this.setState({
            editNoteOpen: !currentState,
            modalNote: ncopy,
        });
    }

    generateNote(note) {
        let nta = this.state.selectedNoteTypesArray;

        if (note.noteCategory && nta.length > 0 && nta.indexOf(note.noteCategory) === -1) {
            return;
        }

        return (
            <MDBCard style={ { backgroundColor: "#E2F1FF", marginBottom: '.5rem'}} className={this.state.isOrderDetails ? "orderDetailsNotesCard" : ""}>
                <MDBCardHeader style={ { backgroundColor: "#5881C1"}} className={this.state.isOrderDetails? "orderNoteHeaderPatientPage" : ""}>
                    <MDBRow>
                        <MDBCol size={ "6" } className={ this.state.isOrderDetails ? "noteHeaderDateText" : "noteHeaderNameTextOrderPage"}>
                            {GlobalFunctions.formatDateTime(note.createdAt)}
                        </MDBCol>

                        <MDBCol size={"6"}  className={this.state.isOrderDetails ? "noteHeaderNameText" : "noteHeaderNameTextOrderPage"}>
                            {note.createdBy ? (note.createdBy.firstname === null || note.createdBy.lastname === null ? note.createdBy.username : note.createdBy.firstname + " " + note.createdBy.lastname) : ""}
                            { !this.state.isOrderDetails ? (<MDBIcon
                                className={ this.state.isOrderDetails ? "editNoteButton" : "" }
                                style={ { float: "right", cursor: 'pointer' } }
                                // style={{color: "#fff", padding: 4, float: "right", cursor: 'pointer'}}
                                data-tip={ "Edit" }
                                icon="ellipsis-v"
                                onClick={ () => this.toggleEditModalPopup(note) }
                            />) : null}
                        </MDBCol>
                    </MDBRow>
                </MDBCardHeader>
                <MDBCardBody className={this.state.isOrderDetails ? "orderNotesCardBodyPatientPage" : ""}>
                    <p style={{whiteSpace: "pre-line"}}>{note.text}</p>
                    {this.state.isOrderDetails ? (
                        <MDBRow style={ { display: "flex", justifyContent: "right" } }>
                            <MDBIcon
                                className={"editNoteButton"}
                                style={ { float: "right", cursor: 'pointer' } }
                                data-tip={ "Edit" }
                                icon="ellipsis-v"
                                onClick={ () => this.toggleEditModalPopup(note) }
                            /></MDBRow>
                    ) : null}
                </MDBCardBody>
            </MDBCard>
        );
    }

    generateTaskForOrderDetail(note) {
        let nta = this.state.selectedNoteTypesArray;

        if (note.noteCategory && nta.length > 0 && nta.indexOf(note.noteCategory) === -1) {
            return;
        }

        function renderAssignedTo() {
            if (note.assignedTo) {
                return (
                    <span style={{fontSize: 14}}>
                        {" "}
                        <MDBIcon
                            icon="long-arrow-alt-right"
                            data-tip={"Assigned To"}
                        />{" "}
                        {note.assignedTo.firstname === null || note.assignedTo.lastname === null ? note.assignedTo.username : note.assignedTo.firstname + " " + note.assignedTo.lastname}
                    </span>
                );
            }
        }

        return (
            <MDBCard style={ { backgroundColor: "#E2F1FF", marginBottom: '1rem'}} className={this.state.isOrderDetails ? "orderDetailsNotesCard" : ""}>
                <MDBCardHeader style={ { backgroundColor: "#5881C1"}} className={this.state.isOrderDetails? "orderNoteHeaderPatientPage" : ""}>
                    <MDBRow>
                        <MDBCol size={ "6" } className={ this.state.isOrderDetails ? "noteHeaderDateText" : "noteHeaderNameTextOrderPage"}>
                            {GlobalFunctions.formatDateTime(note.createdAt)}
                        </MDBCol>

                        <MDBCol size={"6"}  className={this.state.isOrderDetails ? "noteHeaderNameText" : "noteHeaderNameTextOrderPage"}>
                            {note.createdBy ? (note.createdBy.firstname === null || note.createdBy.lastname === null ? note.createdBy.username : note.createdBy.firstname + " " + note.createdBy.lastname) : ""}
                            { !this.state.isOrderDetails ? (<MDBIcon
                                className={ this.state.isOrderDetails ? "editNoteButton" : "" }
                                style={ { float: "right", cursor: 'pointer' } }
                                // style={{color: "#fff", padding: 4, float: "right", cursor: 'pointer'}}
                                data-tip={ "Edit" }
                                icon="ellipsis-v"
                                onClick={ () => this.toggleEditModalPopup(note) }
                            />) : null}
                        </MDBCol>
                    </MDBRow>
                    <MDBRow>
                        <MDBCol size={ "9" } className={  "noteHeaderDateText" }>
                            {renderAssignedTo()}
                        </MDBCol>
                        <MDBCol size={"3"}  className={"noteHeaderNameText" }>
                            <MDBIcon
                                style={{
                                    color: "#7B626E",
                                    float: "right",
                                    padding: "4px 8px 4px 4px",
                                }}
                                onClick={() => this.updateNote(note, true)}
                                data-tip={"Complete"}
                                icon="check"
                            />
                        </MDBCol>
                    </MDBRow>
                </MDBCardHeader>
                <MDBCardBody className={this.state.isOrderDetails ? "orderNotesCardBodyPatientPage" : ""}>
                    <p style={{whiteSpace: "pre-line"}}>{note.text}</p>
                    {this.state.isOrderDetails ? (
                        <MDBRow style={ { display: "flex", justifyContent: "right" } }>
                            <MDBIcon
                                className={"editNoteButton"}
                                style={ { float: "right", cursor: 'pointer' } }
                                data-tip={ "Edit" }
                                icon="ellipsis-v"
                                onClick={ () => this.toggleEditModalPopup(note) }
                            />
                            {/* <MDBIcon
                                style={{
                                    color: "#7B626E",
                                    float: "right",
                                    padding: "4px 8px 4px 4px",
                                }}
                                onClick={() => this.updateNote(note, true)}
                                data-tip={"Complete"}
                                icon="check"
                            /> */}

                        </MDBRow>
                    ) : null}
                </MDBCardBody>
            </MDBCard>
        );
    }

    generateTask(note) {
        function renderAssignedTo() {
            if (note.assignedTo) {
                return (
                    <span style={{fontSize: 14}}>
                        {" "}
                        <MDBIcon
                            icon="long-arrow-alt-right"
                            data-tip={"Assigned To"}
                        />{" "}
                        {note.assignedTo.firstname === null || note.assignedTo.lastname === null ? note.assignedTo.username : note.assignedTo.firstname + " " + note.assignedTo.lastname}
                    </span>
                );
            }
        }

        let nta = this.state.selectedNoteTypesArray;

        if (note.noteCategory && nta.length > 0 && nta.indexOf(note.noteCategory) === -1) {
            return;
        }

        return (
            <MDBCard style={{backgroundColor: "#FFE4F1"}}>
                <MDBCardHeader style={{backgroundColor: "#FFCCE5"}}>
                    <MDBRow>
                        <MDBCol size={"5"} style={{fontSize: 14}}>
                            {GlobalFunctions.formatDateTime(note.createdAt)}
                        </MDBCol>

                        <MDBCol size={"5"} style={{fontSize: 14}}>
                            {note.createdBy ? (note.createdBy.firstname === null || note.createdBy.lastname === null ? note.createdBy.username : note.createdBy.firstname + " " + note.createdBy.lastname) : ""}
                            {renderAssignedTo()}
                        </MDBCol>

                        <MDBCol siz={"2"}>
                            <MDBIcon
                                onClick={() => this.toggleEditModalPopup(note)}
                                style={{
                                    color: "#7B626E",
                                    float: "right",
                                    padding: "4px 4px 4px 8px",
                                }}
                                data-tip={"Edit"}
                                icon="ellipsis-v"
                            />
                            <MDBIcon
                                style={{
                                    color: "#7B626E",
                                    float: "right",
                                    padding: "4px 8px 4px 4px",
                                }}
                                onClick={() => this.updateNote(note, true)}
                                data-tip={"Complete"}
                                icon="check"
                            />
                        </MDBCol>
                    </MDBRow>
                </MDBCardHeader>

                <MDBCardBody>
                    <p style={{whiteSpace: "pre-line"}}>{note.text}</p>
                </MDBCardBody>
                <ReactTooltip/>
            </MDBCard>
        );
    }

    renderNotesSection() {
        let notes = this.sortNotes(this.state.allNotes);
        if(this.state.isOrderDetails){
            return (
                <div>
                    {notes.map((n, idx) => {
                        return (
                            <div key={idx} style={{paddingBottom: 6}}>
                                {(n.assignedTo) && (!n.completed) ? this.generateTaskForOrderDetail(n) : this.generateNote(n)}
                            </div>
                        );
                    })}
                </div>
            );
        }else

            return (
                <div>
                    {notes.map((n, idx) => {
                        return (
                            <div key={idx} style={{paddingBottom: 6}}>
                                {this.generateNote(n)}
                            </div>
                        );
                    })}
                </div>
            );

    }



    renderTasksSection() {
        let tasks = this.sortNotes(this.state.allNotes, true);

        return (
            <div>
                {tasks.map((n, idx) => {
                    return (
                        <div key={idx} style={{paddingBottom: 6}}>
                            {this.generateTask(n)}
                        </div>
                    );
                })}
            </div>
        );
    }

    renderEditNoteModal() {
        let note = this.state.modalNote,
            isTask = note.completed === false;

        let bgClass = "orderNotesModal",
            bgColor = "#FFF7D1";

        if (isTask) {
            bgClass = "orderTasksModal";
            bgColor = "#FFE4F1";
        }
        return (
            <MDBModal
                className={bgClass}
                centered
                isOpen={this.state.editNoteOpen}
                toggle={() => this.toggleEditModalPopup()}
            >
                <MDBModalBody>
                    <MDBRow>
                        <MDBCol size="12">
                            <textarea
                                id={"noteTextArea"}
                                style={{
                                    width: "100%",
                                    height: "200px",
                                    backgroundColor: bgColor,
                                }}
                            >
                                {note.text}
                            </textarea>
                        </MDBCol>

                        <MDBCol size="12">
                            <span>Updated: {GlobalFunctions.formatDateTime(GlobalFunctions.getUTCDate())}</span>

                            <MDBIcon
                                style={{color: "#7B626E", float: "right", padding: 4}}
                                data-tip={"Update"}
                                icon="check"
                                onClick={() => {
                                    this.updateNoteModal(note);
                                    this.toggleEditModalPopup();
                                }}
                            />
                        </MDBCol>
                    </MDBRow>
                </MDBModalBody>
                <ReactTooltip/>
            </MDBModal>
        );
    }

    // noteTypeFiltersArray(array, index) {
    // 	if (array.includes(index)) {
    // 		return array.pop(index);
    // 	} else {
    // 		return array.push(index);
    // 	}
    // }

    // setOutline() {
    // 	let outline = true;
    // 	return !outline;
    // }

    // handleFilterButtonClick() {
    // 	this.noteTypeFiltersArray();
    // 	this.setOutline()
    // }

    handleFilterButtonClick(array, button) {
        if (array.indexOf(button) === true) {
            return true;
        } else {
            return false;
        }
    }

    toggleNoteTypes(type, all) {
        let nta = this.state.selectedNoteTypesArray,
            idx = nta.indexOf(type);

        if (all === true) {
            nta = [];
        } else if (idx > -1) {
            nta.splice(idx, 1);
        } else {
            nta.push(type);
        }

        this.setState({
            selectedNoteTypesArray: nta
        });
    }

    renderFilterButtons() {
        let noteTypesArray = this.state.selectedNoteTypesArray;

        return (
            <MDBRow>
                <MDBCol size="12">

                    <MDBBtn
                        outline={noteTypesArray.length > 0}
                        rounded
                        size="sm"
                        color="info"
                        className="px-2 "
                        onClick={() => this.toggleNoteTypes("", true)}
                    >
                        Show All
                        {/*<MDBIcon icon="scroll"/>*/}
                    </MDBBtn>

                    <MDBBtn
                        outline={noteTypesArray.indexOf("Sales") === -1}
                        rounded
                        size="sm"
                        color="success"
                        className="px-2 "
                        onClick={() => this.toggleNoteTypes("Sales")}
                    >
                        Sales
                        {/*<MDBIcon icon="money-bill"/>*/}
                    </MDBBtn>

                    <MDBBtn
                        outline={noteTypesArray.indexOf("Internal Operations") === -1}
                        size="sm"
                        rounded
                        color="warning"
                        className="px-2"
                        onClick={() => this.toggleNoteTypes("Internal Operations")}
                    >
                        Internal Operations
                        {/*<MDBIcon icon="people-carry"/>*/}
                    </MDBBtn>

                    <MDBBtn
                        outline={noteTypesArray.indexOf("Field Operations") === -1}
                        rounded
                        size="sm"
                        color="danger"
                        className="px-2"
                        onClick={() => this.toggleNoteTypes("Field Operations")}
                    >
                        Field Operations
                        {/*<MDBIcon icon="truck-loading"/>*/}
                    </MDBBtn>

                    <MDBBtn
                        outline={noteTypesArray.indexOf("Billing") === -1}
                        rounded
                        size="sm"
                        color={"secondary"}
                        className="px-2"
                        onClick={() => this.toggleNoteTypes("Billing")}
                    >
                        Billing
                        {/*<MDBIcon icon="credit-card"/>*/}
                    </MDBBtn>
                </MDBCol>
            </MDBRow>
        );
    }

    renderBtnsOrderDetailsModal() {
        return (
            <MDBBtnGroup vertical style={ { float: "right", marginLeft: '.5rem' } }>
                <MDBBtn
                    size="med"
                    className="addNoteBtn"
                    onClick={ () => this.toggleNoteModalPopup() }
                >
                Add Note
                </MDBBtn>
                {/* { this.state.eOrder.status === 3 ? (
            <MDBBtn
                size="med"
                color="default"
                className="px-2"
            onClick={ () =>
                this.toggleFieldNotesModalPopup()
            }
            >
                View Field Notes
            </MDBBtn>) : "" }
            <MDBBtn
                size="med"
                color="default"
                className="px-2"
            onClick={ () => this.downloadNotes() }
            >
                Export Notes
            </MDBBtn> */}
            </MDBBtnGroup>
        );
    }

    render() {
        return (
            <div>
                <MDBCol size="12">
                    <div style={{justifyContent: "center"}}>
                        {/*{new Date(this.state.eOrder.followUpDate).toLocaleDateString()}*/}
                        {/*{this.renderFilterButtons()}*/}
                    </div>
                    {/*{ this.state.isOrderDetails ? (this.renderBtnsOrderDetailsModal()) : null }*/}
                </MDBCol>
                { this.renderEditNoteModal() }


                <MDBRow>
                    <MDBCol className={"pvNotesGroupOuterContainer"} size={this.state.fullWidth ? "12" : "6"}>
                        <div className={ "pvNotesGroupInnerContainer" }>
                            { this.renderNotesSection() }
                        </div>
                    </MDBCol>
                    {!this.state.isOrderDetails ? (<MDBCol className={"pvNotesGroupOuterContainer"} size={this.state.fullWidth ? "12" : "6"}>
                        <div className={ "pvNotesGroupInnerContainer" }>
                            { this.renderTasksSection() }
                        </div>
                    </MDBCol>) : null }

                </MDBRow>
            </div>
        );
    }
}
